var _circle, _circle2, _g, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserImgEx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 83,
    viewBox: "0 0 80 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_195_12348",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#D4D4D4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_195_12348)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.8359,
    y: 56.666,
    width: 57.5,
    height: 25.8333,
    rx: 12.9167,
    fill: "#F3F4F5"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.9974,
    cy: 34.1673,
    r: 15.8333,
    fill: "#F3F4F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserImgEx);
export default __webpack_public_path__ + "static/media/user_img_ex.7636fe2496cc2ad7b32c158fbf509fdd.svg";
export { ForwardRef as ReactComponent };